<template>
  <div class="container-configuracao-atual">
    <div class="container-foto-empresa">
      <v-img v-if="parametroAtual.fotoEmpresa"
             :src="createUrl(parametroAtual.fotoEmpresa)"
             class="foto-empresa"
             aspect-ratio="4/3"
             lazy-src="/images/loading.gif"
      />
      <v-img v-else
             src="/images/avatares/avatar-padrao.png"
             class="foto-empresa"
             aspect-ratio="4/3"
             lazy-src="/images/loading.gif"
      />
      <label>Foto empresa</label>
    </div>
    <div class="container-info-configuracoes">
      <div class="container-info-separacao mb-2">
        <span>Sistema de Cores</span>
      </div>
      <div class="container-cores">
        <div class="container-info-cor mr-5">
          <span>Cor primária</span>
          <div :style="`--cor-parametro: ${parametroAtual.corPrimaria}`"/>
        </div>
        <div class="container-info-cor mr-5">
          <span>Cor secundária</span>
          <div :style="`--cor-parametro: ${parametroAtual.corSecundaria}`"/>
        </div>
        <div class="container-info-cor">
          <span>Cor terciária</span>
          <div :style="`--cor-parametro: ${parametroAtual.corTerciaria}`"/>
        </div>
      </div>
      <div class="container-info-separacao mt-5 mb-2">
        <span>Parâmetros adicionais</span>
      </div>
      <div class="container-info-cor">
        <span>Timezone/Fuso Horário</span>
        <p>{{ dadosEmpresa.timezone }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'ParametrosVerConfiguracaoAtual',
    props: {
        dadosEmpresa: Object,
        parametroAtual: Object,
    }
}
</script>


<style scoped lang="stylus">

.container-configuracao-atual
  display flex


.container-foto-empresa
  text-align center
  font-weight bold
  color var(--theme-primary)

.foto-empresa
  border-radius 50%
  border 2px solid #eee
  height 315px
  width 315px

.container-info-configuracoes
  margin-left 10px
  padding 5px
  width 100%

.container-info-separacao
  border-bottom 1px solid #ddd
  font-weight bold
  color var(--theme-primary)

.container-cores
  display flex

.container-info-cor
  span
    color var(--theme-primary)

  p
    font-size 14px

  div
    height 25px
    width 100%
    border-radius 5px
    border 2px solid #1e1e1e
    background-color var(--cor-parametro)

</style>